/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_ActionInputs */



/**

* @param {Footer_ActionInputs} inputs
* @param {{ locale?: "es" }} options
* @returns {LocalizedString}
*/
export const footer_action = /** @type {((inputs?: Footer_ActionInputs, options?: { locale?: "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_ActionInputs, { locale?: "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Actúa")
});